import React from 'react';

const SplashScreen = () => {
  return (
    <div className="splash-screen">
      <div className="splash-logo">AMALIKA WORLD</div>
      <div className="splash-tagline">Speak Languages. Build Robots. Code the Future.</div>
    </div>
  );
};

export default SplashScreen;